var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCopy = function SvgIconCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Copy",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    strokeWidth: 0
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Custom-Preset",
    stroke: "#979797",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 1c1.518 0 2.923.483 4.07 1.304a7.018 7.018 0 0 1 2.704 3.923 7.015 7.015 0 0 1 3.922 2.703A6.967 6.967 0 0 1 31 13v11a6.978 6.978 0 0 1-2.05 4.95A6.978 6.978 0 0 1 24 31H13a6.967 6.967 0 0 1-4.07-1.304 7.018 7.018 0 0 1-2.704-3.923 7.015 7.015 0 0 1-3.922-2.703A6.967 6.967 0 0 1 1 19V8c0-1.933.784-3.683 2.05-4.95A6.978 6.978 0 0 1 8 1Z",
    id: "Combined-Shape",
    "data-no-fill": "true"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 6,
    y: 6,
    width: 25,
    height: 25,
    rx: 8,
    "data-no-fill": "true"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.092,
    y1: 12.5,
    x2: 26.222,
    y2: 12.5,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.092,
    y1: 18.5,
    x2: 26.222,
    y2: 18.5,
    id: "Path",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.092,
    y1: 24.5,
    x2: 26.222,
    y2: 24.5,
    id: "Path",
    strokeLinecap: "round"
  })))));
};
export { SvgIconCopy as ReactComponent };
export default "data:image/svg+xml;base64,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";